
import { runInAction, makeAutoObservable, reaction } from "mobx";
import { TabProps } from "semantic-ui-react";
import { store } from "./store";

interface Tab {
    predicate: string;
    activeIndex: number;
}

export default class TabStore {
    tab: Tab = {
        predicate: 'active',
        activeIndex: 0
    }

    constructor() {
        makeAutoObservable(this);
        
        reaction(
            () => this.tab.predicate, // when keys changes
            () => { // run this
                store.permitStore.permitRegistry.clear();
                store.permitStore.loadPermits();
            }
        )
    }

    setPredicate = (tabKey: string) => {
        this.tab.predicate = tabKey;
    }

    handleTabChange = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, data: TabProps) => {
        runInAction(() => {
            let i = +data.activeIndex!;
            let panes = data.panes!;
            let pane: any = panes[i].pane;

            this.setPredicate(pane.key);
            this.tab.activeIndex = i;
        });
    }
}